import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accesability-statement',
  templateUrl: './accesability-statement.component.html',
  styleUrls: ['./accesability-statement.component.scss']
})
export class AccesabilityStatementComponent implements OnInit, OnDestroy {
  private langSub: Subscription;

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => {});
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }
}
